"use client";
import * as React from "react";
import {
  Content as RadixAlertDialogContent,
  type ContentProps as RadixAlertDialogContentProps,
  Description as RadixAlertDialogDescription,
  type DescriptionProps as RadixAlertDialogDescriptionProps,
} from "@radix-ui/themes/components/alert-dialog";
import { useElement } from "../widgets-context.js";
import { getDomProps, namespaceClassNames } from "../utils.js";
import { useDialogOverlayHack } from "./utils.js";

interface ContentProps extends RadixAlertDialogContentProps {}

const AlertDialogContent = React.forwardRef<HTMLDivElement, ContentProps>(
  function AlertDialogContent({ className, ...props }, forwardedRef) {
    const element = useElement("dialog");
    const { ref } = useDialogOverlayHack(forwardedRef, {
      className: namespaceClassNames("dialog-overlay"),
      selector: ".rt-DialogOverlay",
    });
    return (
      <RadixAlertDialogContent
        ref={ref}
        {...getDomProps({ elementId: "dialog", className })}
        {...props}
        {...element}
      />
    );
  },
);

interface DescriptionProps extends RadixAlertDialogDescriptionProps {}

const AlertDialogDescription = React.forwardRef<
  HTMLParagraphElement,
  DescriptionProps
>(function AlertDialogDescription({ size = "2", ...props }, forwardedRef) {
  return (
    <RadixAlertDialogDescription ref={forwardedRef} size={size} {...props} />
  );
});

export { AlertDialogContent as Content, AlertDialogDescription as Description };
export type { ContentProps, DescriptionProps };

export {
  Action,
  Cancel,
  Root,
  Title,
  Trigger,
} from "@radix-ui/themes/components/alert-dialog";
export type {
  ActionProps,
  CancelProps,
  RootProps,
  TitleProps,
  TriggerProps,
} from "@radix-ui/themes/components/alert-dialog";
